<template>
  <router-view/>
</template>

<script>

export default {
  components: {
  }
}
</script>

<style>
@import '@/assets/style/styles.css';
</style>
